import { JobApplicationStatusKey, StatusSentiment } from '@restworld/utility-types';
import { useCallback, useMemo } from 'react';

export function useJobApplicationCategoriesNavigation() {
  const jobApplicationCategories = useMemo(() => ['in_evaluation', 'active', 'inactive'], []);

  const getJobCategoryNavigation = useCallback(
    ({ statusKey, statusSentiment }: { statusSentiment: StatusSentiment; statusKey: JobApplicationStatusKey }) => {
      if (statusSentiment === 'positive' && statusKey !== 'worker_jp_interested') {
        return jobApplicationCategories[1];
      } else if (statusSentiment === 'negative' || statusKey === 'worker_jp_hired') {
        return jobApplicationCategories[2];
      }
      return jobApplicationCategories[0];
    },
    [jobApplicationCategories]
  );

  return {
    jobApplicationCategories,
    getJobCategoryNavigation,
  };
}
